import forge from "node-forge";
import axios from "axios";


async function Heisenberg(option, url , sid) {

    option.ChangeTheGame = 'DoNotLetTheGameChangeYou!'
    option.ch = 'shop'
    if (sid){ let id = PinkMan(localStorage.getItem('sid') , 'de'); option.sid = id}
    const DOM = "https://market-app.ir/"


     // const world = '4444555566667777';
    //  const cipher = forge.cipher.createCipher('AES-CBC', world);
    //  // رمزگذاری داده
    //  cipher.start({iv:'I8zyA4lVhMCaJ5Kg'});
    //  cipher.update(forge.util.createBuffer(JSON.stringify(option)));
    //  cipher.finish();
    // let data = forge.util.encode64(cipher.output.data);

    const response = await axios.post(DOM + url, option)
    return response;
}

 function PinkMan(data, type) {

    const world = '4444555566667777';

    if (type == 'en') {

        const cipher = forge.cipher.createCipher('AES-CBC', world);
        // رمزگذاری داده
        cipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        cipher.update(forge.util.createBuffer(JSON.stringify(data)));
        cipher.finish();
        let i = forge.util.encode64(cipher.output.data);
        return i
    }

    if (type == 'de') {

        const decipher = forge.cipher.createDecipher('AES-CBC', world);
        decipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        decipher.update(forge.util.createBuffer(forge.util.decode64(data)));
        decipher.finish();
        let i = JSON.parse(decipher.output.toString());
        return i
    }


}


export default {Heisenberg , PinkMan};